export const SELECTED_OPTIONS = {
  USERNAME_PASSWORD: 'username/password',
  IP_AUTH: 'ipauth',
};

export const SIP_IP_ADDRESS = '172.16.16.1';
export const SIP_IP_ADDRESS_WITHOUT_ONE = SIP_IP_ADDRESS.substring(0, SIP_IP_ADDRESS.length - 1);
export const SIP_PORT = '6060';
